import { render, staticRenderFns } from "./mineMenu.vue?vue&type=template&id=2d12bd35&scoped=true&"
import script from "./mineMenu.vue?vue&type=script&lang=js&"
export * from "./mineMenu.vue?vue&type=script&lang=js&"
import style0 from "./mineMenu.vue?vue&type=style&index=0&id=2d12bd35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d12bd35",
  null
  
)

export default component.exports